import React from 'react';
import { Box, Typography } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { PLR_ALLIANCE_COPY, PLR_RESULT_TIME } from './heroVariant';

type DesktopPanelProps = {
  image: string;
  projectName: string;
  entityName?: string;
  primary: string;
  accent: string;
};

export default function PlrDesktopProjectPanel({
  image,
  projectName,
  entityName,
  primary,
  accent,
}: DesktopPanelProps) {
  return (
    <Box
      data-pw="preloan-project-card"
      sx={{
        position: 'relative',
        flex: 'none',
        width: '100%',
        height: 560,
        borderRadius: '28px',
        overflow: 'hidden',
        border: '1px solid #E6E6EE',
      }}
    >
      <Box
        component="img"
        src={image}
        alt=""
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 0.7,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: 24,
          right: 24,
          bottom: 24,
          bgcolor: '#fff',
          borderRadius: '20px',
          p: 3,
          textAlign: 'left',
          boxShadow: '0 8px 30px rgba(16, 24, 40, 0.08)',
        }}
      >
        {entityName && (
          <Typography
            variant="overline"
            display="block"
            sx={{ color: accent, fontWeight: 700, letterSpacing: 1.1 }}
          >
            {entityName}
          </Typography>
        )}
        <Typography
          data-pw="preloan-project-name"
          variant="h4"
          fontWeight="bold"
          sx={{ color: primary, lineHeight: 1.15 }}
        >
          {projectName}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748d', mt: 0.5, mb: 2 }}>
          {PLR_ALLIANCE_COPY}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccessTimeOutlinedIcon sx={{ color: accent, fontSize: 18 }} />
          <Typography variant="body2" sx={{ color: accent }}>
            {PLR_RESULT_TIME}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

PlrDesktopProjectPanel.defaultProps = {
  entityName: undefined,
};
